import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import { callApp } from '@ifeng-fe/callapp';

const isVideoShare = (typeof window === 'object' && window.allData && window.allData.isVideoShare) || false;

class Desc extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        pageInfo: PropTypes.object,
        fromPage: PropTypes.string,
    };

    handleClick = (params, name) => {
        // 统计
        this.pageCount(name);

        const { type, id, userId } = params;
        const doc_type = type;
        const aid = id;
        const kind = 'inter_fxy02';
        const client = isVideoShare ? 'videoApp' : 'newsApp';

        callApp({
            client,
            docType: doc_type,
            pid: aid,
            userId,
            kind,
        });
    };

    getKind = (fromPage, fromType) => {
        let kind = '';

        if (fromPage === 'home') {
            if (fromType === 'source') {
                kind = 'main_tag';
            } else {
                kind = 'vampire';
            }
        } else {
            kind = 'selfpage';
        }

        return kind;
    };

    pageCount = name => {
        const { fromPage, fromType } = this.props.pageInfo;
        let reportType = '';

        if (name === 'like') {
            reportType = 'zmtvote';
        } else if (name === 'share') {
            reportType = 'zmtshare';
        } else if (name === 'commit') {
            reportType = 'zmtcom';
        }

        h5PageCount([
            {
                behavior: 'action',
                type: reportType,
                other: {
                    ref: encodeURIComponent(decodeURIComponent(location.href)),
                    kind: this.getKind(fromPage, fromType),
                },
            },
        ]);
    };

    render() {
        const { content, pageInfo = {} } = this.props;
        const { like_num, comment_num } = content;

        return (
            <div className={styles.desc}>
                <div className={styles.wrap} onClick={() => this.handleClick(pageInfo, 'like')}>
                    <span className={styles.like}>{Number(like_num) > 0 ? like_num : '赞'}</span>
                </div>
                <div className={styles.wrap} onClick={() => this.handleClick(pageInfo, 'commit')}>
                    <span className={styles.comment}>{Number(comment_num) > 0 ? comment_num : '评论'}</span>
                </div>
                <div className={styles.wrap} onClick={() => this.handleClick(pageInfo, 'share')}>
                    <span className={styles.share}>转发</span>
                </div>
            </div>
        );
    }
}

export default errorBoundary(Desc);
